import React, {useEffect, useState} from 'react';
// import Logo from "./static/image/f1.png";
import Logo from "./static/image/CodersTrust_text_Only.svg";
// import Logo from "./static/image/CTLogo.svg";
import {Link, NavLink, useHistory} from "react-router-dom";
import {ReactComponent as Notification} from "./static/image/cart-icon.svg";
import {ReactComponent as Message} from "./static/image/message.svg";
import default_profile_picture from "./static/image/man.png";
import profile_picture from "./static/image/man2.svg";
import AxiosServices from "../../networks/AxiosService";
import ApiUrlServices from "../../networks/ApiUrlServices";
import config from "../../config";
import path from "../../routes/path";
import CustomPageLoader from "../customPageLoader";
import './styles/header.scss';
import {getFirebaseToken} from "../../helper/CommonFunctions";
import {toast} from 'react-toastify';
import Commonbutton from "../button/Button";
import {ReactComponent as SearchIcon} from "./static/image/Search.svg";
import Cross from "./static/image/error.png";

const Header = (props) => {
    const [pageLoader, setPageLoader] = useState(false)
    const [loggedIn, setLoggedIn] = useState(false)
    const [cardImage, setCardImage] = useState(null);
    const [totalCartItem, setTotalCartItem] = useState(Number(localStorage.getItem("totalCartItem")));
    const [userData, setUserData] = useState({})
    const [courseName, setCourseName] = useState("");
    const history = useHistory();

    useEffect(() => {
        setCardImage(props.profilePicture)
    }, [props.profilePicture])

    useEffect(() => {
        if (props.cartCountIncrement) {
            setTotalCartItem(totalCartItem + 1)
            localStorage.setItem("totalCartItem", JSON.stringify(totalCartItem + 1));
        }
    }, [props.cartCountIncrement])

    useEffect(() => {
        let sessionUserData = JSON.parse(localStorage.getItem('userData'));
        if (sessionUserData === undefined || sessionUserData === null) {
            setCardImage(profile_picture)
            setLoggedIn(false)
            setUserData({})
        } else {
            (sessionUserData.profile_picture === undefined || sessionUserData.profile_picture === '') ? setCardImage(default_profile_picture) : setCardImage(sessionUserData.profile_picture)
            getTotalCartItem(sessionUserData.userId)
            setLoggedIn(true)
            setUserData(sessionUserData)
        }

    }, [])

    useEffect(() => {
        if (typeof props.data?.totalCartItem !== typeof undefined) {
            setTotalCartItem(props.data.totalCartItem);
            localStorage.setItem("totalCartItem", props.data.totalCartItem);
        }
    }, [props])

    function logout(e) {
        setPageLoader(true)
        e.preventDefault()
        localStorage.clear()
        document.cookie.split(";").forEach(function (c) {
            document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });
        if (userData['signinSource'] === 'REGULAR') {
            let payload = {
                accessToken: userData.accessToken
            }

            AxiosServices.post(ApiUrlServices.SIGN_OUT, payload, false)
                .then((response) => {
                    console.log(response);
                    history.push(
                        {pathname: path.home}
                    )
                })
                .catch((error) => {
                    console.log(error)
                    history.push(
                        {pathname: path.home}
                    )
                });
        } else {
            if (userData['signinSource'] === 'AUTH0') {
                window.location.href = "https://ctapi.coderstrust.net/prod/auth/authentication/linkedin-logout/tPeQKj9T9wtx2rrHIIUShty70tjgij8a/coderstrust-login/"

                    // config.API_URL.social_api_base_url +
                    // `/logout?client_id=` +
                    // config.aws.cognito_app_client_id +
                    // `&logout_uri=` +
                    // config.API_URL.api_base_url +
                    // `/auth/authentication/linkedin-logout/` +
                    // config.aws.auth0_app_client_id +
                    // `/` + config.API_URL.auth0_redirected_endpoint + `/`
            } else {
                window.location.href =
                    config.API_URL.social_api_base_url +
                    `/logout?client_id=` +
                    config.aws.cognito_app_client_id +
                    `&logout_uri=` +
                    config.API_URL.web_base_url +
                    path.home;
            }
        }


        // UnRegister device from FCM.....
        getFirebaseToken().then(token => {
            let payload = {
                user_id: userData.userId,
                channel_type: 'GCM',
                endpoint_address: token
            }
            AxiosServices.post(ApiUrlServices.UNREGISTER_DEVICE, payload, false).then(response => {
                console.log(response)
            }).catch(error => {
                console.log(error)
                console.log(error.response)
                // toast.error(error.response.data.message)
            })
        })

    }

    function redirectToMyCart() {
        history.push(`${path.my_cart}`)
    }

    const getTotalCartItem = (user_id) => {
        AxiosServices.get(ApiUrlServices.COUNT_CART_ITEM(user_id)).then(res => {
            setTotalCartItem(res.data.data.cart_count || 0);
            localStorage.setItem("totalCartItem", res.data.data.cart_count);
        }).catch(err => {
            console.log(err)
        })
    }

    const searchCourseByName = () => {
        if (courseName.length < 3 && courseName.length) {
            toast.error("Name length should be at least 3");
        } else {
            history.push({
                pathname: path.course_list,
                state: {courseName: courseName}
            });
            setCourseName("");
        }
    }

    const resetSearchField = () => {
        setCourseName("");
    }

    const SearchSection = () => {
        return (
            <div className="dropdown search-top-bar">
                <button className="btn btn-secondary dropdown-toggle" type="button"
                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false">
                    <SearchIcon/>
                </button>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    {SearchSection()}
                    <div className="search-container navbar-top">
                        <form autoComplete="off"
                              onSubmit={e => {
                                  e.preventDefault();
                                  searchCourseByName();
                              }}>
                            <input
                                className="header-search"
                                type="text"
                                placeholder="Search Course"
                                value={courseName}
                                onChange={
                                    e => {
                                        setCourseName(e.target.value);
                                    }
                                }
                            />
                            {
                                courseName.length === 0 ? null :
                                    <button onClick={resetSearchField}
                                            className="close-icon1"
                                            type="reset">
                                        <img src={Cross} alt=""/>
                                    </button>
                            }
                        </form>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <CustomPageLoader pageLoader={pageLoader}/>
            <nav className="navbar navbar-expand-lg navbar-dark sticky-top">
                <div className="header-nav">
                    <div className="logo-site navbar-brand">
                        <Link to={path.home}>
                                    <span>
                                        <img src={Logo} className="coder-trust-image" alt=""/>
                                        <span className="slogan">Learn a Skill; the World is Yours</span>
                                    </span>
                        </Link>
                    </div>

                    <button className="navbar-toggler" type="button" data-toggle="collapse"
                            data-target="#navbarCollapse"
                            aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"/>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarCollapse">

                        <div className="search-container navbar-top search-top">
                            <form autoComplete="off"
                                  onSubmit={e => {
                                      e.preventDefault();
                                      searchCourseByName();
                                  }}>
                                <input
                                    className="header-search"
                                    type="text"
                                    placeholder="Search Course"
                                    value={courseName}
                                    onChange={
                                        e => {
                                            setCourseName(e.target.value);
                                        }
                                    }
                                />
                                {
                                    courseName.length === 0 ? null :
                                        <button onClick={resetSearchField}
                                                className="close-icon1"
                                                type="reset">
                                            <img src={Cross} alt=""/>
                                        </button>
                                }
                            </form>
                        </div>

                        <div className="collapse navbar-collapse navbar-middle home"
                             id="bs-example-navbar-collapse-1 home">
                            <ul className="nav navbar-nav ">
                                <li>
                                    <NavLink to={path.home} exact activeClassName="current selected">
                                        Home
                                    </NavLink>
                                </li>
                            </ul>
                        </div>

                        <div className="collapse navbar-collapse navbar-middle "
                             id="bs-example-navbar-collapse-1 course">
                            <ul className="nav navbar-nav">
                                <li>
                                    <NavLink to={path.course_list} exact activeClassName="current selected">
                                        Courses
                                    </NavLink>
                                </li>
                            </ul>
                        </div>

                        <div className="collapse navbar-collapse navbar-middle "
                             id="bs-example-navbar-collapse-1 about-us">
                            <ul className="nav navbar-nav">
                                <li>
                                    <NavLink to={path.about_us} exact activeClassName="current selected">
                                        About
                                    </NavLink>
                                </li>
                            </ul>
                        </div>

                        <div className="collapse navbar-collapse navbar-middle "
                             id="bs-example-navbar-collapse-1 contact-us">
                            <ul className="nav navbar-nav">
                                <li>
                                    <NavLink to={path.contact_us} exact activeClassName="current selected">
                                        Contact
                                    </NavLink>
                                </li>
                            </ul>
                        </div>


                        {/* <div className="collapse navbar-collapse navbar-middle"
                                     id="bs-example-navbar-collapse-1">
                                    <ul className="nav navbar-nav">
                                        <li><a id="home" href={path.about_us}>About</a></li>
                                    </ul>
                                </div> */}

                        {/* <div className="collapse navbar-collapse navbar-middle"
                                     id="bs-example-navbar-collapse-1">
                                    <ul className="nav navbar-nav">
                                        <li><a id="home" href={void (0)}>News</a></li>
                                    </ul>
                                </div> */}

                        {/* <div className="collapse navbar-collapse navbar-middle"
                                     id="bs-example-navbar-collapse-1">
                                    <ul className="nav navbar-nav">
                                        <li><a id="home" href={path.contact_us}>Contact</a></li>
                                    </ul>
                                </div> */}

                        <ul className="nav navbar-nav pull-right top-nav navbar-top">
                            {
                                JSON.parse(localStorage.getItem('userData'))?.userId ? <>
                                    <div className="dropdown search-top-bar " style={{display: "none"}}>
                                        <button className="btn btn-secondary dropdown-toggle" type="button"
                                                id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                aria-expanded="false">
                                            <SearchIcon/>
                                        </button>
                                        <div className="dropdown-menu  login-navbar"
                                             aria-labelledby="dropdownMenuButton">
                                            <div className="search-container navbar-top">
                                                <form
                                                    autoComplete="off"
                                                    onSubmit={e => {
                                                        e.preventDefault();
                                                        searchCourseByName();
                                                    }}>
                                                    <input
                                                        className="header-search"
                                                        type="text"
                                                        placeholder="Search Course"
                                                        value={courseName}
                                                        onChange={
                                                            e => {
                                                                setCourseName(e.target.value);
                                                            }
                                                        }
                                                    />
                                                    {
                                                        courseName.length === 0 ? null :
                                                            <button onClick={resetSearchField}
                                                                    className="close-icon1"
                                                                    type="reset">
                                                                <img src={Cross} alt=""/>
                                                            </button>
                                                    }
                                                </form>
                                            </div>
                                        </div>
                                    </div>

                                    <li className="dropdown dropdown-notification">
                                        <a className="dropdown-toggle"
                                           href={void (0)}
                                           data-toggle="dropdown"
                                           data-hover="dropdown"
                                           data-close-others="true"
                                           aria-expanded="true"
                                           onClick={redirectToMyCart}
                                        >
                                            <Notification className="notification-icon"/>
                                            <span className="badge badge-default"> {totalCartItem} </span>
                                        </a>

                                    </li>
                                    {/*<li className="dropdown dropdown-notification">*/}
                                    {/*    <a className="dropdown-toggle"*/}
                                    {/*       href={void (0)}*/}
                                    {/*       data-toggle="dropdown"*/}
                                    {/*       data-hover="dropdown"*/}
                                    {/*       data-close-others="true"*/}
                                    {/*       aria-expanded="true">*/}
                                    {/*        <Message className="message"/> </a>*/}
                                    {/*</li>*/}
                                    {/*<li className="dropdown dropdown-notification">*/}
                                    {/*    <a className="dropdown-toggle"*/}
                                    {/*       href={void (0)}*/}
                                    {/*       data-toggle="dropdown"*/}
                                    {/*       data-hover="dropdown"*/}
                                    {/*       data-close-others="true"*/}
                                    {/*       aria-expanded="true">*/}
                                    {/*        <i className="fa fa-bell-o"/>*/}
                                    {/*        /!*<span*!/*/}
                                    {/*        /!*    className="badge badge-default"> 13*!/*/}
                                    {/*        /!*</span>*!/*/}
                                    {/*    </a>*/}

                                    {/*<ul className="dropdown-menu">*/}
                                    {/*    <li className="external">*/}
                                    {/*        <h3><span className="bold">12 pending</span> notifications</h3>*/}
                                    {/*        <a href={void (0)}>view all</a>*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        <ul className="dropdown-menu-list">*/}
                                    {/*            <li><a href={void (0)}> <span*/}
                                    {/*                className="time">10 mins</span> <span*/}
                                    {/*                className="details"> <span*/}
                                    {/*                className="label label-sm label-icon btn-warning"> <i*/}
                                    {/*                className="fa fa-bell-o"/> </span> Server not responding. </span>*/}
                                    {/*            </a></li>*/}
                                    {/*        </ul>*/}
                                    {/*    </li>*/}
                                    {/*</ul>*/}
                                    {/*</li>*/}
                                </> : ''
                            }


                            <li className="dropdown ">

                                {
                                    JSON.parse(localStorage.getItem('userData'))?.userId ?
                                        <>
                                            <a href="#" className="dropdown-toggle profile-img"
                                               data-toggle="dropdown"
                                               aria-expanded="true">
                                                <img alt="" className="img-circle"
                                                     src={cardImage}
                                                     width="30"/>
                                            </a>
                                            <ul className="dropdown-menu">
                                                <li>
                                                    <Link to={path.profile}>
                                                        <i className="fa fa-fw fa-user"/> My Profile
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to={path.mentor_courses}>
                                                        <i className="fa fa-fw fa-book"/> My Courses
                                                    </Link>
                                                </li>
                                                <li className="divider"/>
                                                <li onClick={logout} style={{cursor: "pointer"}}>
                                                    <a href={void (0)}>
                                                        <i className="fa fa-fw fa-power-off"/>
                                                        Logout

                                                    </a>
                                                </li>
                                            </ul>
                                        </>
                                        :
                                        <>
                                            <div className="d-flex ">

                                                <div className="dropdown search-top-bar search-box-login"
                                                     style={{display: "none", marginRight: "8px"}}>
                                                    <button className="btn btn-secondary dropdown-toggle" type="button"
                                                            id="dropdownMenuButton" data-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false">
                                                        <SearchIcon/>
                                                    </button>
                                                    <div className="dropdown-menu search-input-field"
                                                         aria-labelledby="dropdownMenuButton">
                                                        <div className="search-container navbar-top">
                                                            <form autoComplete="off"
                                                                  onSubmit={e => {
                                                                      e.preventDefault();
                                                                      searchCourseByName();
                                                                  }}>
                                                                <input
                                                                    className="header-search"
                                                                    type="text"
                                                                    placeholder="Search Course"
                                                                    value={courseName}
                                                                    onChange={
                                                                        e => {
                                                                            setCourseName(e.target.value);
                                                                        }
                                                                    }
                                                                />
                                                                {
                                                                    courseName.length === 0 ? null :
                                                                        <button onClick={resetSearchField}
                                                                                className="close-icon1"
                                                                                type="reset">
                                                                            <img src={Cross} alt=""/>
                                                                        </button>
                                                                }
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>

                                                <Commonbutton
                                                    type="button"
                                                    onclickCallback={() => {
                                                        history.push(path.registration)
                                                    }}
                                                    btnText="Registration"
                                                    inputClassName="registration-btn auth-registration-btn"

                                                />
                                                <Commonbutton
                                                    type="button"
                                                    onclickCallback={() => {
                                                        history.push(path.login)
                                                    }}
                                                    btnText="Login"
                                                    inputClassName="login-btn"

                                                />
                                            </div>
                                        </>
                                }


                                {/*<ul className="dropdown-menu">*/}
                                {/*    {*/}
                                {/*        loggedIn ? <>*/}
                                {/*                <li>*/}
                                {/*                    <Link to={path.profile}>*/}
                                {/*                        <i className="fa fa-fw fa-user"/> My Profile*/}
                                {/*                    </Link>*/}
                                {/*                </li>*/}
                                {/*                <li>*/}
                                {/*                    <Link to={path.mentor_courses}>*/}
                                {/*                        <i className="fa fa-fw fa-book"/> My Courses*/}
                                {/*                    </Link>*/}
                                {/*                </li>*/}
                                {/*                <li className="divider"/>*/}
                                {/*                <li onClick={logout} style={{cursor: "pointer"}}>*/}
                                {/*                    <a href={void (0)}>*/}
                                {/*                        <i className="fa fa-fw fa-power-off"/>*/}
                                {/*                        Logout*/}
                                {/*                    </a>*/}
                                {/*                </li>*/}
                                {/*            </>*/}
                                {/*            :*/}
                                {/*            <>*/}
                                {/*                <li>*/}
                                {/*                    <Link to={path.registration}>*/}
                                {/*                        <i className="fa fa-fw fa-user-plus"/> Sign Up*/}
                                {/*                    </Link>*/}
                                {/*                </li>*/}
                                {/*                <li>*/}
                                {/*                    <Link to={path.login}>*/}
                                {/*                        <i className="fa fa-fw fa-sign-in"/> Login*/}
                                {/*                    </Link>*/}
                                {/*                </li>*/}
                                {/*            </>*/}
                                {/*    }*/}
                                {/*</ul>*/}
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Header;
